import(/* webpackMode: "eager" */ "/var/www/html/prod/src/components/newsMedia/allNews/index.tsx")